import { render, staticRenderFns } from "./TranProgramModuleView.vue?vue&type=template&id=9c943618&scoped=true"
import script from "./TranProgramModuleView.vue?vue&type=script&lang=js"
export * from "./TranProgramModuleView.vue?vue&type=script&lang=js"
import style0 from "./TranProgramModuleView.vue?vue&type=style&index=0&id=9c943618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c943618",
  null
  
)

export default component.exports